import { DetailSection, VenueDetailCard } from 'components/Find/detail';
import type { FindVenueDetails } from 'components/Find/types';

interface Props {
  locations: FindVenueDetails[];
  /** `lg`: heading and cards step up from lg, for Figma's wider "Modal M". */
  sizeDesktop?: 'lg';
}

export default function PlayerPreferredLocations({ locations, sizeDesktop }: Props) {
  return (
    <DetailSection title={`Preferred locations: ${locations.length}`} sizeDesktop={sizeDesktop}>
      <div className="flex flex-col gap-ds-md">
        {locations.map((venue, index) => (
          <VenueDetailCard key={`${venue.name}-${index}`} venue={venue} sizeDesktop={sizeDesktop} />
        ))}
      </div>
    </DetailSection>
  );
}
